export function getScrollTop() {
	return window.pageYOffset || document.body.scrollTop;
}
export function getScrollLeft() {
	return window.pageXOffset || document.body.scrollLeft;
}



//////////////////
// WEBPACK FOOTER
// ./~/get-scroll/dist/get-scroll.es-modules.js
// module id = Z22t
// module chunks = 0